import { CreditStudyId, DocumentationId, EmploymentSituationName } from '../models';

export class CreateDocumentationCommand {
  public readonly _tag = 'CreateDocumentationCommand';
  constructor(public readonly creditStudy: CreditStudyId) {}
}

export class SpecifyDocumentationTypeCommand {
  public readonly _tag = 'SpecifyDocumentationTypeCommand';
  constructor(
    public readonly documentation: DocumentationId,
    public readonly userDeclaresRent: boolean,
    public readonly employmentSituation: EmploymentSituationName
  ) {}
}
